<template>
  <div class="ws-exam-groups-list__item-tags">
    <span class="ws-exam-groups-list__item-tags__item ws-exam-groups-list__item-tags__item--program">{{ getProgram }}</span>
    <span class="ws-exam-groups-list__item-tags__item ws-exam-groups-list__item-tags__item--level">{{ getLevel }}</span>
    <span v-if="getProf" class="ws-exam-groups-list__item-tags__item ws-exam-groups-list__item-tags__item--prof">{{ getProf }}</span>
  </div>
</template>

<script>
import { get } from 'lodash-es'
export default {
  name: 'WsStudyGroupTags',
  props: {
    study_group: Object
  },
  computed: {
    getProgram () {
      let programDisplay = get(this.study_group, 'edu_program.level.title.display')
      let matches = programDisplay && programDisplay.match(/^(Программа )*(.*)( - )/i)
      return matches.length ? matches[2] : ''
    },
    getLevel () {
      let levelDisplay = get(this.study_group, 'edu_program.level.title.display')
      let matches = levelDisplay && levelDisplay.match(/( - )(.*)/i)
      return matches.length ? matches[2] : ''
    },
    getProf () {
      let profDisplay = get(this.study_group, 'edu_program_is_prof')
      return profDisplay ? 'ПРОФЕССИОНАЛИТЕТ' : ''
    }
  }
}
</script>
